import { gaPushEvent } from "../base.analytics";

enum Event {
  APP_FOREGROUNDED = "app_foregrounded",
}

/**
 * The link that opened the app, reduced to what may leave the device: the host,
 * plus the first path segment when the link is on the app's own host.
 *
 * Never the whole URL. Some app paths carry a capability (`/v/:token`,
 * `/gpt/shared/:token`), and a short link on another host (`s.juisci.com/…`)
 * is worth exactly what its target is. Either one sent to GA4 or Mixpanel is a
 * copy of the secret that revoking the link does not revoke
 * (`.knowledge/mixpanel-capability-url-leak.md`). The route family says which
 * kind of link brought the reader back. The page they land on reports its own
 * content through its own events.
 */
function deepLinkParam(deepLink: string): string {
  const url = new URL(deepLink);
  if (url.hostname !== globalThis.location.hostname) return url.hostname;
  const segment = url.pathname.split("/")[1];
  if (segment === undefined) {
    throw new Error(
      `should not happen: a URL pathname always starts with "/" (${url.pathname})`
    );
  }
  return segment === "" ? url.hostname : `${url.hostname}/${segment}`;
}

/**
 * The installed app came back to the screen, or started. Native shells only:
 * a browser tab never sends the bridge message this reports.
 *
 * `foreground_source` and not `source`: GA4 already reads `source` as the
 * traffic source of a campaign.
 */
export function gaEventAppForegrounded(params: {
  source: "cold_start" | "resume";
  deepLink: string | null;
}) {
  gaPushEvent(Event.APP_FOREGROUNDED, {
    foreground_source: params.source,
    deep_link: params.deepLink === null ? null : deepLinkParam(params.deepLink),
  });
}
